/**
 * Product Overview Widget
 * Handles pagination, infinite scroll, lazy loading, and filters
 * Only loads if widget is present on page
 */

(function () {
    'use strict';

    const CMProductOverview = {
        grids: [],
        selectedCategories: [],
        selectedBrands: [],

        init() {
            const grids = document.querySelectorAll('.cm-products-grid[data-pagination]');
            
            if (!grids.length) {
                return;
            }

            this.initFilters();

            grids.forEach(grid => {
                const paginationType = grid.dataset.pagination;
                
                if (paginationType === 'infinite') {
                    this.initInfiniteScroll(grid);
                }
            });
        },

        initFilters() {
            const urlParams = new URLSearchParams(window.location.search);
            const filterCat = urlParams.get('filter_cat');
            const filterBrand = urlParams.get('filter_brand');

            if (filterCat) {
                this.selectedCategories = filterCat.split(',');
            }
            if (filterBrand) {
                this.selectedBrands = filterBrand.split(',');
            }

            const filterItems = document.querySelectorAll('.cm-filter-item');
            
            filterItems.forEach(item => {
                const filterType = item.dataset.filterType;
                const filterId = item.dataset.filterId;
                
                if (filterType === 'category' && this.selectedCategories.includes(filterId)) {
                    item.classList.add('active');
                } else if (filterType === 'brand' && this.selectedBrands.includes(filterId)) {
                    item.classList.add('active');
                }
                
                item.addEventListener('click', (e) => {
                    e.preventDefault();
                    
                    if (filterType === 'category') {
                        this.toggleFilter('category', filterId, item);
                    } else if (filterType === 'brand') {
                        this.toggleFilter('brand', filterId, item);
                    }
                });
            });
        },

        toggleFilter(type, id, item) {
            const isActive = item.classList.contains('active');
            
            if (isActive) {
                item.classList.remove('active');
                if (type === 'category') {
                    this.selectedCategories = this.selectedCategories.filter(catId => catId !== id);
                } else if (type === 'brand') {
                    this.selectedBrands = this.selectedBrands.filter(brandId => brandId !== id);
                }
            } else {
                item.classList.add('active');
                if (type === 'category') {
                    this.selectedCategories.push(id);
                } else if (type === 'brand') {
                    this.selectedBrands.push(id);
                }
            }

            this.updateUrlAndReload();
        },

        updateUrlAndReload() {
            const url = new URL(window.location.href);
            
            if (this.selectedCategories.length > 0) {
                url.searchParams.set('filter_cat', this.selectedCategories.join(','));
            } else {
                url.searchParams.delete('filter_cat');
            }

            if (this.selectedBrands.length > 0) {
                url.searchParams.set('filter_brand', this.selectedBrands.join(','));
            } else {
                url.searchParams.delete('filter_brand');
            }

            url.searchParams.delete('product-page');

            window.location.href = url.toString();
        },

        initInfiniteScroll(grid) {
            const trigger = grid.closest('.cm-product-overview');
            if (!trigger) return;

            const loadingSpinner = trigger.querySelector('.cm-loading-spinner');
            const loadMoreButton = trigger.querySelector('.cm-load-more-button');
            
            if (!loadingSpinner && !loadMoreButton) {
                return;
            }

            let currentPage = parseInt(grid.dataset.currentPage) || 1;
            const totalPages = parseInt(grid.dataset.totalPages) || 1;
            const perPage = parseInt(grid.dataset.perPage) || 12;
            const columns = grid.dataset.columns || 4;
            const orderby = grid.dataset.orderby || 'menu_order';
            const categoryId = grid.dataset.categoryId || '';
            const tagId = grid.dataset.tagId || '';
            const filterCat = grid.dataset.filterCat || '';
            const filterBrand = grid.dataset.filterBrand || '';

            if (currentPage >= totalPages) {
                if (loadingSpinner) loadingSpinner.parentElement.style.display = 'none';
                return;
            }

            if (loadMoreButton) {
                loadMoreButton.style.display = 'inline-block';
                loadMoreButton.addEventListener('click', () => {
                    this.loadMoreProducts(grid, loadingSpinner, loadMoreButton, currentPage, totalPages, perPage, columns, orderby, categoryId, tagId, filterCat, filterBrand);
                });
            }

            if (loadingSpinner) {
                const observer = new IntersectionObserver((entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting && !loadingSpinner.dataset.loaded) {
                            loadingSpinner.dataset.loaded = 'true';
                            this.loadMoreProducts(grid, loadingSpinner, loadMoreButton, currentPage, totalPages, perPage, columns, orderby, categoryId, tagId, filterCat, filterBrand);
                        }
                    });
                }, { rootMargin: '100px' });

                observer.observe(trigger);
            }
        },

        async loadMoreProducts(grid, loadingSpinner, loadMoreButton, currentPage, totalPages, perPage, columns, orderby, categoryId, tagId, filterCat, filterBrand) {
            if (currentPage >= totalPages) {
                if (loadMoreButton) loadMoreButton.style.display = 'none';
                if (loadingSpinner) loadingSpinner.style.display = 'none';
                return;
            }

            const nextPage = currentPage + 1;

            if (loadingSpinner) {
                loadingSpinner.style.display = 'block';
            }
            if (loadMoreButton) {
                loadMoreButton.style.display = 'none';
            }

            try {
                const ajaxUrl = typeof cm_ajax !== 'undefined' ? cm_ajax.ajax_url : '/wp-admin/admin-ajax.php';
                const nonce = typeof cm_ajax !== 'undefined' ? cm_ajax.nonce : '';

                const params = new URLSearchParams({
                    action: 'cm_product_overview_load_more',
                    page: nextPage,
                    per_page: perPage,
                    columns: columns,
                    orderby: orderby,
                    nonce: nonce
                });

                if (categoryId) {
                    params.append('category_id', categoryId);
                }

                if (tagId) {
                    params.append('tag_id', tagId);
                }

                if (filterCat) {
                    params.append('filter_cat', filterCat);
                }

                if (filterBrand) {
                    params.append('filter_brand', filterBrand);
                }

                const response = await fetch(`${ajaxUrl}?${params.toString()}`);
                const data = await response.json();

                if (data.success && data.data.html) {
                    const tempContainer = document.createElement('div');
                    tempContainer.innerHTML = data.data.html;
                    
                    const newTiles = tempContainer.querySelectorAll('.cm-product-tile');
                    newTiles.forEach(tile => {
                        grid.appendChild(tile);
                    });

                    grid.dataset.currentPage = nextPage;

                    if (nextPage >= totalPages) {
                        if (loadMoreButton) loadMoreButton.style.display = 'none';
                        if (loadingSpinner) loadingSpinner.style.display = 'none';
                    } else {
                        if (loadMoreButton) {
                            loadMoreButton.style.display = 'inline-block';
                        }
                        if (loadingSpinner) {
                            loadingSpinner.dataset.loaded = '';
                            loadingSpinner.style.display = 'none';
                        }
                    }
                }
            } catch (error) {
                console.error('Error loading more products:', error);
                if (loadMoreButton) loadMoreButton.style.display = 'inline-block';
                if (loadingSpinner) loadingSpinner.style.display = 'none';
            }
        }
    };

    document.addEventListener('DOMContentLoaded', () => CMProductOverview.init());
    window.elementorFrontend && window.elementorFrontend.on('document:loaded', () => CMProductOverview.init());

})();
